import { createFileRoute } from "@tanstack/react-router";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";
import { WarehouseFrontDoor } from "@bfc-software/bfc-web-ui/ui/shared/warehouse-front-door";

/**
 * The Engine Room's front door, where it picks up a warehouse.
 *
 * Every Engine Room screen is warehouse-scoped, so this is where that gets
 * decided. The mechanics are the same for any warehouse-scoped product and live
 * in WarehouseFrontDoor; all this route contributes is which product is asking
 * and where it wants to land.
 */
export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/internal/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { lang } = Route.useParams();
  const { t } = useTranslation({
    lang,
    namespace: TRANSLATION_NAMESPACE.portal,
  });

  return (
    <WarehouseFrontDoor
      product={t("products.internal.title")}
      to="/$lang/orgs/$org/internal/whs/$location/home"
    />
  );
}
